module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"authRequired":"Vous devez être authentifié pour utiliser cette page.","adminRequired":"Cette page est réservée aux administrateurs."},"en":{"authRequired":"You must be logged in to use this page.","adminRequired":"This page is reserved for admins."}}')
  delete Component.options._Ctor
}
